import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Header = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(34),
  fontWeight: 'bold',
  letterSpacing: '0.01941em',
  marginTop: 0,
  marginBottom: theme.spacing(2.5),

  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.pxToRem(24),
    letterSpacing: '0.055em',
  },
}));
